<div class="popup-container">
  <div class="popup-content">
    <a class="btn-close" (click)="closePopup()"></a>
    <div class="header">
      <h4>{{ title }}</h4>
      <app-selector
        [options]="options"
        [autoClose]="true"
        [selected]="selected"
        [class.comparison]="comparedOption"
        (onSelectOption)="changeOption($event)"
      ></app-selector>
    </div>
    <div class="table">
      <div class="heading">
        <div
          class="column"
          *ngFor="let col of columns"
          [class.selected]="col.selected"
        >
          <a
            [class.sortable]="col.sortable"
            [class.sorted]="isSortBy(col.key)"
            [class.desc]="isSortDesc(col.key)"
            (click)="sort(col)"
          >
            {{ col.title | translate }}
          </a>
        </div>
      </div>
      <div class="content custom-scrollbar">
        <div class="row" *ngFor="let row of tableContent">
          <div
            class="cell"
            *ngFor="let col of columns"
            [class.selected]="col.selected"
          >
            {{
              col.numeric
                ? (row[col.key] | hideZeroValues : '1.0-0')
                : row[col.key]
            }}
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
